import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5d2edfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "ion-text-center" }
const _hoisted_4 = { class: "ion-text-center" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "ion-text-center" }
const _hoisted_10 = { class: "ion-text-center" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "actions" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "ion-text-center" }
const _hoisted_17 = { class: "ion-text-center" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "actions" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_21 = { class: "desktop-only" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_JobConfiguration = _resolveComponent("JobConfiguration")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_fab = _resolveComponent("ion-fab")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_menu_button, { slot: "start" }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Rule pipeline")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_segment, {
                modelValue: _ctx.segmentSelected,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.segmentSelected) = $event)),
                onIonChange: _ctx.segmentChanged
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_segment_button, { value: "pending" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("Pending")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_segment_button, { value: "running" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("Running")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_segment_button, { value: "history" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("History")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "onIonChange"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("main", null, [
            (_ctx.segmentSelected === 'pending')
              ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
                  (_ctx.pendingJobs?.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("There are no jobs pending right now")), 1),
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_ion_button, {
                            fill: "outline",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refreshJobs(undefined, true)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('retry')) + " ", 1),
                              (_ctx.isRetrying)
                                ? (_openBlock(), _createBlock(_component_ion_spinner, {
                                    key: 0,
                                    name: "crescent"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingJobs, (job) => {
                          return (_openBlock(), _createBlock(_component_ion_card, {
                            key: job.jobId,
                            onClick: ($event: any) => (_ctx.viewJobConfiguration(job)),
                            button: _ctx.isDesktop
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_header, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.getEnumName(job.systemJobEnumId)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (job.runTime)
                                    ? (_openBlock(), _createBlock(_component_ion_badge, {
                                        key: 0,
                                        color: "dark"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.timeFromNow(job.runTime)), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_item, { lines: "none" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, _toDisplayString(job.jobName), 1),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.getEnumDescription(job.systemJobEnumId)), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              (job.runtimeData && job.runtimeData.threshold !== null && job.runtimeData.threshold !== undefined)
                                ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.optionsOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(job.runtimeData.threshold) + " " + _toDisplayString(_ctx.$t('threshold')), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (job.runtimeData && job.runtimeData.searchPreferenceId)
                                ? (_openBlock(), _createBlock(_component_ion_item, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.checkmarkCircleOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getTags(job.runtimeData.searchPreferenceId, "included") ? _ctx.getTags(job.runtimeData.searchPreferenceId, "included") : "-"), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (job.runtimeData && job.runtimeData.searchPreferenceId)
                                ? (_openBlock(), _createBlock(_component_ion_item, { key: 2 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.closeCircleOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getTags(job.runtimeData.searchPreferenceId, "excluded") ? _ctx.getTags(job.runtimeData.searchPreferenceId, "excluded") : "-"), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: _ctx.timeOutline
                                  }, null, 8, ["icon"]),
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(job.runTime ? _ctx.getTime(job.runTime) : "-"), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_item, { lines: "full" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: _ctx.timerOutline
                                  }, null, 8, ["icon"]),
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(job.tempExprId ? _ctx.temporalExpr(job.tempExprId)?.description : "🙃"), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_ion_button, {
                                    disabled: !_ctx.hasPermission(_ctx.Actions.APP_JOB_UPDATE),
                                    fill: "clear",
                                    onClick: _withModifiers(($event: any) => (_ctx.skipJob(job)), ["stop"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("Skip")), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["disabled", "onClick"]),
                                  _createVNode(_component_ion_button, {
                                    disabled: !_ctx.hasPermission(_ctx.Actions.APP_JOB_UPDATE),
                                    color: "danger",
                                    fill: "clear",
                                    onClick: _withModifiers(($event: any) => (_ctx.cancelJob(job)), ["stop"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("Cancel")), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["disabled", "onClick"])
                                ]),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_ion_button, {
                                    fill: "clear",
                                    color: "medium",
                                    slot: "end",
                                    onClick: _withModifiers(($event: any) => (_ctx.copyJobInformation(job)), ["stop"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "icon-only",
                                        icon: _ctx.copyOutline
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_component_ion_button, {
                                    fill: "clear",
                                    color: "medium",
                                    slot: "end",
                                    onClick: _withModifiers(($event: any) => (_ctx.viewJobHistory(job)), ["stop"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "icon-only",
                                        icon: _ctx.timeOutline
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onClick", "button"]))
                        }), 128)),
                        _createVNode(_component_ion_refresher, {
                          slot: "fixed",
                          onIonRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refreshJobs($event)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_refresher_content, {
                              pullingIcon: "crescent",
                              refreshingSpinner: "crescent"
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_infinite_scroll, {
                          onIonInfinite: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMorePendingJobs($event))),
                          threshold: "100px",
                          disabled: !_ctx.isPendingJobsScrollable
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_infinite_scroll_content, {
                              "loading-spinner": "crescent",
                              "loading-text": _ctx.$t('Loading')
                            }, null, 8, ["loading-text"])
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]))
                ]))
              : _createCommentVNode("", true),
            (_ctx.segmentSelected === 'running')
              ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
                  (_ctx.runningJobs?.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("There are no jobs running right now")), 1),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_ion_button, {
                            fill: "outline",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.refreshJobs(undefined, true)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('retry')) + " ", 1),
                              (_ctx.isRetrying)
                                ? (_openBlock(), _createBlock(_component_ion_spinner, {
                                    key: 0,
                                    name: "crescent"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.runningJobs, (job) => {
                          return (_openBlock(), _createBlock(_component_ion_card, {
                            key: job.jobId
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_header, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_ion_card_subtitle, { class: "overline" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(job.parentJobId), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_card_title, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.getEnumName(job.systemJobEnumId)), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _createVNode(_component_ion_badge, { color: "dark" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Running")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_item, { lines: "none" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, _toDisplayString(job.jobName), 1),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.getEnumDescription(job.systemJobEnumId)), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              (job.runtimeData && job.runtimeData.threshold !== null && job.runtimeData.threshold !== undefined)
                                ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.optionsOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(job.runtimeData.threshold) + " " + _toDisplayString(_ctx.$t('threshold')), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (job.runtimeData && job.runtimeData.searchPreferenceId)
                                ? (_openBlock(), _createBlock(_component_ion_item, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.checkmarkCircleOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getTags(job.runtimeData.searchPreferenceId, "included") ? _ctx.getTags(job.runtimeData.searchPreferenceId, "included") : "-"), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (job.runtimeData && job.runtimeData.searchPreferenceId)
                                ? (_openBlock(), _createBlock(_component_ion_item, { key: 2 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.closeCircleOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getTags(job.runtimeData.searchPreferenceId, "excluded") ? _ctx.getTags(job.runtimeData.searchPreferenceId, "excluded") : "-"), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: _ctx.timeOutline
                                  }, null, 8, ["icon"]),
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(job.runTime ? _ctx.getTime(job.runTime) : "-"), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_item, { lines: "full" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: _ctx.timerOutline
                                  }, null, 8, ["icon"]),
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(job.tempExprId ? _ctx.temporalExpr(job.tempExprId)?.description : "🙃"), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("div", _hoisted_12, [
                                _hoisted_13,
                                _createElementVNode("div", null, [
                                  _createVNode(_component_ion_button, {
                                    fill: "clear",
                                    color: "medium",
                                    slot: "end",
                                    onClick: _withModifiers(($event: any) => (_ctx.copyJobInformation(job)), ["stop"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "icon-only",
                                        icon: _ctx.copyOutline
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_component_ion_button, {
                                    fill: "clear",
                                    color: "medium",
                                    slot: "end",
                                    onClick: _withModifiers(($event: any) => (_ctx.viewJobHistory(job)), ["stop"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "icon-only",
                                        icon: _ctx.timeOutline
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        _createVNode(_component_ion_refresher, {
                          slot: "fixed",
                          onIonRefresh: _cache[5] || (_cache[5] = ($event: any) => (_ctx.refreshJobs($event)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_refresher_content, {
                              pullingIcon: "crescent",
                              refreshingSpinner: "crescent"
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_infinite_scroll, {
                          onIonInfinite: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadMoreRunningJobs($event))),
                          threshold: "100px",
                          disabled: !_ctx.isRunningJobsScrollable
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_infinite_scroll_content, {
                              "loading-spinner": "crescent",
                              "loading-text": _ctx.$t('Loading')
                            }, null, 8, ["loading-text"])
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]))
                ]))
              : _createCommentVNode("", true),
            (_ctx.segmentSelected === 'history')
              ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
                  (_ctx.jobHistory?.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("No jobs have run yet")), 1),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_ion_button, {
                            fill: "outline",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.refreshJobs(undefined, true)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('retry')) + " ", 1),
                              (_ctx.isRetrying)
                                ? (_openBlock(), _createBlock(_component_ion_spinner, {
                                    key: 0,
                                    name: "crescent"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobHistory, (job) => {
                          return (_openBlock(), _createBlock(_component_ion_card, {
                            key: job.jobId
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_header, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_ion_card_subtitle, { class: "overline" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(job.parentJobId), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_card_title, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.getEnumName(job.systemJobEnumId)), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _createElementVNode("div", null, [
                                    (job.cancelDateTime || job.finishDateTime)
                                      ? (_openBlock(), _createBlock(_component_ion_badge, {
                                          key: 0,
                                          color: "dark"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(job.statusId == "SERVICE_CANCELLED" || job.statusId == "SERVICE_CRASHED" ?  _ctx.timeFromNow(job.cancelDateTime) : _ctx.timeFromNow(job.finishDateTime)), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true),
                                    (job.statusId)
                                      ? (_openBlock(), _createBlock(_component_ion_badge, {
                                          key: 1,
                                          color: job.statusId === 'SERVICE_FINISHED' ? 'success' : 'danger'
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(job.statusDesc), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["color"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_item, { lines: "none" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, _toDisplayString(job.jobName), 1),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.getEnumDescription(job.systemJobEnumId)), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              (job.runtimeData && job.runtimeData.threshold !== null && job.runtimeData.threshold !== undefined)
                                ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.optionsOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(job.runtimeData.threshold) + " " + _toDisplayString(_ctx.$t('threshold')), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (job.runtimeData && job.runtimeData.searchPreferenceId)
                                ? (_openBlock(), _createBlock(_component_ion_item, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.checkmarkCircleOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getTags(job.runtimeData.searchPreferenceId, "included") ? _ctx.getTags(job.runtimeData.searchPreferenceId, "included") : "-"), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (job.runtimeData && job.runtimeData.searchPreferenceId)
                                ? (_openBlock(), _createBlock(_component_ion_item, { key: 2 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: _ctx.closeCircleOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getTags(job.runtimeData.searchPreferenceId, "excluded") ? _ctx.getTags(job.runtimeData.searchPreferenceId, "excluded") : "-"), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: _ctx.timeOutline
                                  }, null, 8, ["icon"]),
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(job.runTime ? _ctx.getTime(job.runTime) : "-"), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_note, { slot: "end" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(job.statusId == "SERVICE_CANCELLED" || job.statusId == "SERVICE_CRASHED" ? _ctx.getJobExecutionTime(job.startDateTime, job.cancelDateTime) : _ctx.getJobExecutionTime(job.startDateTime, job.finishDateTime)), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_item, { lines: "full" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: _ctx.timerOutline
                                  }, null, 8, ["icon"]),
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(job.tempExprId ? _ctx.temporalExpr(job.tempExprId)?.description : "🙃"), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("div", _hoisted_19, [
                                _hoisted_20,
                                _createElementVNode("div", null, [
                                  _createVNode(_component_ion_button, {
                                    fill: "clear",
                                    color: "medium",
                                    slot: "end",
                                    onClick: _withModifiers(($event: any) => (_ctx.copyJobInformation(job)), ["stop"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "icon-only",
                                        icon: _ctx.copyOutline
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_component_ion_button, {
                                    fill: "clear",
                                    color: "medium",
                                    slot: "end",
                                    onClick: _withModifiers(($event: any) => (_ctx.viewJobHistory(job)), ["stop"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "icon-only",
                                        icon: _ctx.timeOutline
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        _createVNode(_component_ion_refresher, {
                          slot: "fixed",
                          onIonRefresh: _cache[8] || (_cache[8] = ($event: any) => (_ctx.refreshJobs($event)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_refresher_content, {
                              pullingIcon: "crescent",
                              refreshingSpinner: "crescent"
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_infinite_scroll, {
                          onIonInfinite: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadMoreJobHistory($event))),
                          threshold: "100px",
                          disabled: !_ctx.isHistoryJobsScrollable
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_infinite_scroll_content, {
                              "loading-spinner": "crescent",
                              "loading-text": _ctx.$t('Loading')
                            }, null, 8, ["loading-text"])
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]))
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("aside", _hoisted_21, [
              (_openBlock(), _createBlock(_component_JobConfiguration, {
                title: _ctx.title,
                job: _ctx.currentJob,
                productCount: _ctx.productCount,
                status: _ctx.currentJobStatus,
                type: _ctx.freqType,
                key: _ctx.currentJob
              }, null, 8, ["title", "job", "productCount", "status", "type"]))
            ], 512), [
              [_vShow, _ctx.segmentSelected === 'pending' && _ctx.currentJob]
            ])
          ]),
          (_ctx.segmentSelected === 'pending' && _ctx.pendingJobs?.length !== 0)
            ? (_openBlock(), _createBlock(_component_ion_fab, {
                key: 0,
                vertical: "bottom",
                horizontal: "end",
                slot: "fixed"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_fab_button, {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.openReorderModal()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.pencilOutline }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}